import { DialogProps } from '.'
import useId from '../../hooks/useId'
import MainHeader from '../MainHeader'
import Message from '../Message'
import { DialogBody, DialogHeader, DialogWrapper } from './Dialog.styles'

const Dialog = ({
  className = '',
  open = false,
  closeActions,
  modalBox,
  'data-testid': testid = 'dialog',
  ...props
}: DialogProps) => {
  const { getTestId } = useId(testid)
  return (
    <DialogWrapper
      className={`Dialog ${className}`}
      open={open}
      closeActions={closeActions}
      data={props?.data}
      data-testid={getTestId()}
      {...modalBox}>
      {!!closeActions && (
        <DialogHeader className="DialogHeader">
          <MainHeader
            className="DialogMainHeader"
            data-testid={getTestId('header')}
            buttons={[
              {
                icon: 'MdClose',
                actions: () => closeActions({ data: props?.data }),
                'data-testid': 'close'
              }
            ]}
          />
        </DialogHeader>
      )}
      <DialogBody className="DialogBody" data-testid={getTestId('body')}>
        <Message
          className="DialogMessage"
          data-testid={getTestId('message')}
          {...props}
        />
      </DialogBody>
    </DialogWrapper>
  )
}

export default Dialog
